<template>
    <b-modal id="invoiceConfirmModal" modal-class="client-details-modal" centered size="lg" hide-header-close
        hide-footer>
        <template #modal-header>
            <div class="view-clients-header">
                <h6 class="modal-refund-title">Confirm Refund? </h6>
                <b-button variant="close-btn" class="btn-container" @click="closeModal">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>
        <b-container fluid>
            <div class="view-clients-modal-content">
                <div class="addMessage-form">

                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <td><strong>ID:</strong></td>
                                <td>{{row.paymentID }}</td>
                            </tr>
                            <tr>
                                <td><strong>Member Name:</strong></td>
                                <td>{{row.payment_ben_name }}</td>
                            </tr>
                            <tr>
                                <td><strong>Amount:</strong></td>
                                <td>${{row.payamount }}</td>
                            </tr>
                            <tr>
                                <td><strong>Refund Type:</strong></td>
                                <td>CC</td>
                            </tr>
                            <tr>
                                <td><strong>Card Number:</strong></td>
                                <td>{{billingDetails?.card_num ? 'xxxx-' + billingDetails.card_num : 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td><strong>Card Type:</strong></td>
                                <td>{{billingDetails?.brand?billingDetails?.brand:'N/A' }}</td>
                            </tr>
                          
                        </tbody>
                    </table>
                    <div class="row justify-content-md-center">
                        <div class="col-xxl-5 mb-4">
                            <b-button class="univ-btn" @click="$emit('confirmRefundPayment')">
                                Send
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-container>
    </b-modal>
</template>

<script>
export default {
    name: "InvoiceRefundModal",
    props: {
        row: Object,
        billingDetails:Object
    },
    data: () => ({
        form: {}
    }),
    methods: {
        closeModal() {
            this.$bvModal.hide("invoiceRefundModal");
            this.$emit("onClosedModal");
        }
    },
    onclickHandler() {
        this.$emit('confirmRefundPayment');

    }

};
</script>